import { useEffect, useState } from "react";
import _throttle from "lodash/throttle";

type Breakpoints = "xs" | "sm" | "md" | "lg" | "xl" | "xxl";

const initialWidth = 1200;
const breakpoints: { [key in Breakpoints]: number } = {
    xs: 624,
    sm: 640,
    md: 840,
    lg: 1024,
    xl: 1280,
    xxl: 1440,
};

const useBreakpoint = (breakpoint: Breakpoints): boolean => {
    const [width, setWidth] = useState(initialWidth);

    useEffect(() => {
        const throttledHandleResize = _throttle(() => {
            setWidth(window.innerWidth);
        }, 100);

        throttledHandleResize();
        window.addEventListener("resize", throttledHandleResize);
        return () => {
            window.removeEventListener("resize", throttledHandleResize);
            throttledHandleResize.cancel();
        };
    }, []);

    return width > breakpoints[breakpoint];
};

export default useBreakpoint;
